import React, { useEffect, useRef, useState } from 'react'
import styles from './comment.module.scss'
import { PAGE_SIZE } from 'consts'
import { POSITION_TABLE } from 'consts'
import { useHistory } from 'react-router-dom'
import logoApp from 'assets/img/logo-app.png'
import moment from 'moment'
import FilterRegion from 'components/filter-region'
//components
import FilterDate from 'components/filter-date'

// icons
import { SearchOutlined } from '@ant-design/icons'

//antd
import { Input, Table, Row, Col, Form, Modal, Checkbox } from 'antd'

// apis
import { getComments } from 'apis/comment'

const INIT_RATING_SERVICE = [
  {
    name: 'Service',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Staff',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Food quality',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Food selection',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Drink quality',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Drink selection',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Coffee flavor',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Overall',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
]
export default function Comment() {
  const history = useHistory()

  const [loadingTable, setLoadingTable] = useState(false)
  const [comments, setComments] = useState([])
  const [countPage, setCountPage] = useState('')
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: PAGE_SIZE })
  const [valueSearch, setValueSearch] = useState('')
  const typingTimeoutRef = useRef(null)

  const columns = [
    {
      title: 'STT',
      width: 80,
      align: 'center',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
    },
    {
      title: 'Họ tên',
      dataIndex: 'name',
      align: 'center',
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone',
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Nội dung',
      dataIndex: 'content',
    },
    {
      title: 'Chi nhánh',
      align: 'center',
      render: (text, record) => record.branch_info && record.branch_info.name,
    },
    {
      title: 'Mã đơn hàng',
      align: 'center',
      render: (text, record) => record.order_info && record.order_info.code,
    },
    {
      title: 'Ngày nhận xét',
      dataIndex: 'date_comment',
    },
    {
      title: '',
      align: 'center',
      render: (text, record) => (
        <ModalComment record={record}>
          <a>Xem chi tiết</a>
        </ModalComment>
      ),
    },
  ]

  const ModalComment = ({ children, record }) => {
    const [formComment] = Form.useForm()

    const [ratings, setRatings] = useState(INIT_RATING_SERVICE)

    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)

    useEffect(() => {
      if (!visible) {
        formComment.resetFields()
        setRatings([...INIT_RATING_SERVICE])
      } else {
        if (record) {
          formComment.setFieldsValue({ ...record })
          setRatings([...record.ratings])
        }
      }
    }, [visible])

    return (
      <>
        <div onClick={toggle}>{children}</div>
        <Modal
          style={{ top: 20 }}
          bodyStyle={{ padding: 0 }}
          width={600}
          closable={false}
          visible={visible}
          onCancel={toggle}
          footer={null}
        >
          <div>
            <Row justify="center">
              <img src={logoApp} alt="logo app" style={{ width: 120, marginTop: 15 }} />
            </Row>
            <div style={{ backgroundColor: 'red', height: 11, marginTop: 14 }}></div>
            <div style={{ padding: 20, fontSize: 15 }}>
              <div>
                <div>!Hóla!</div>
                <div>How much did you like us?</div>
              </div>
              <br />
              <div style={{ fontSize: 14, lineHeight: 1 }}>
                <Row wrap={false} style={{ textAlign: 'center' }}>
                  <Col span={5}></Col>
                  <Col span={4}>
                    <Row justify="center">Poor</Row>
                  </Col>
                  <Col span={4}>
                    <Row justify="center">Below Average</Row>
                  </Col>
                  <Col span={4}>
                    <Row justify="center">Average</Row>
                  </Col>
                  <Col span={4}>
                    <Row justify="center">Above Average</Row>
                  </Col>
                  <Col span={4}>
                    <Row justify="center">Excellent</Row>
                  </Col>
                </Row>
                {ratings.map((item, index) => (
                  <Row wrap={false} style={{ marginTop: 15 }}>
                    <Col span={5}>{item.name}</Col>
                    {item.ratings.map((r, indexRatting) => (
                      <Col span={4}>
                        <Row justify="center">
                          <Checkbox
                            style={{ pointerEvents: 'none' }}
                            checked={r.checked}
                            onChange={(e) => {
                              const ratingsNew = [...ratings]
                              ratingsNew[index].ratings[indexRatting].checked = e.target.checked
                              setRatings([...ratingsNew])
                            }}
                          />
                        </Row>
                      </Col>
                    ))}
                  </Row>
                ))}
                <br />
                <Form form={formComment} layout="vertical">
                  <div>
                    <Form.Item initialValue="" label="Name:" name="name">
                      <Input.TextArea style={{ pointerEvents: 'none' }} rows={1} />
                    </Form.Item>
                    <Form.Item initialValue="" label="Phone:" name="phone">
                      <Input.TextArea style={{ pointerEvents: 'none' }} rows={1} />
                    </Form.Item>
                    <Form.Item initialValue="" label="Comment:" name="content">
                      <Input.TextArea style={{ pointerEvents: 'none' }} rows={3} />
                    </Form.Item>
                    <Form.Item
                      initialValue=""
                      label="Email (to join our mailing list):"
                      name="email"
                    >
                      <Input.TextArea style={{ pointerEvents: 'none' }} rows={2} />
                    </Form.Item>
                    <Form.Item
                      initialValue={moment(new Date()).format('DD/MM/YYYY')}
                      label="Date (optional):"
                      name="date_comment"
                    >
                      <Input.TextArea style={{ pointerEvents: 'none' }} rows={1} />
                    </Form.Item>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Modal>
      </>
    )
  }

  const _getComments = async () => {
    try {
      setLoadingTable(true)
      const res = await getComments(paramsFilter)
      console.log(res)
      if (res.status === 200) {
        setComments(res.data.data)
        setCountPage(res.data.count)
      }
      setLoadingTable(false)
    } catch (err) {
      console.log(err)
    }
  }

  const _search = (e) => {
    setValueSearch(e.target.value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(async () => {
      const value = e.target.value
      if (value) paramsFilter.search = value
      else delete paramsFilter.search
      setParamsFilter({ ...paramsFilter, page: 1 })
    }, 650)
  }

  useEffect(() => {
    _getComments()
  }, [paramsFilter])

  return (
    <div className={`${styles['promotion_manager']} ${styles['card']}`}>
      <Row
        wrap={false}
        align="middle"
        justify="space-between"
        style={{ borderBottom: '1px solid rgb(236, 226, 226)', paddingBottom: '0.75rem' }}
      >
        <div style={{ fontWeight: '600', fontSize: '1.2rem' }}>Quản lý nhận xét</div>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Input
            prefix={<SearchOutlined />}
            placeholder="Tìm kiếm theo số điện thoại khách"
            allowClear
            className="search-filter-custom"
            onChange={_search}
            value={valueSearch}
            size="large"
          />
        </Col>
        <FilterRegion
          width_size={400}
          setParamsFilter={setParamsFilter}
          paramsFilter={paramsFilter}
        />
      </Row>
      <br />
      <Table
        rowKey="blog_id"
        size="small"
        loading={loadingTable}
        columns={columns}
        dataSource={comments}
        pagination={{
          position: POSITION_TABLE,
          total: countPage,
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          onChange(page, pageSize) {
            setParamsFilter({
              ...paramsFilter,
              page: page,
              page_size: pageSize,
            })
          },
        }}
      />
    </div>
  )
}
